var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreatment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71581 19.644L1.0495 21.7264H16.3743L14.7085 19.644H2.71581Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71529 31.097H14.7085L16.3743 29.0146H1.0495L2.71529 31.097Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98598 16.5206H13.3972C14.5455 16.5206 15.4794 15.5866 15.4794 14.4382C15.4794 13.2899 14.5455 12.3559 13.3972 12.3559H9.75326V11.3148H12.3238C12.1692 9.73638 11.3248 8.30323 9.98908 7.41252L9.95524 7.39014L9.36597 8.56925C8.84384 9.61249 7.84124 10.3215 6.68456 10.4662C5.46645 10.6182 4.54766 11.6589 4.54766 12.8869V13.3971H6.6299V14.4382H2.98598C2.4118 14.4382 1.94485 14.9052 1.94485 15.4794C1.94485 16.0536 2.4118 16.5206 2.98598 16.5206ZM7.67102 13.3971H8.71214V14.4382H7.67102V13.3971Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42431 18.6032H16C16.2873 18.6032 16.5206 18.3699 16.5206 18.0826C16.5206 17.7952 16.2873 17.562 16 17.562H13.3972H2.98599H1.42431C1.13696 17.562 0.903748 17.7952 0.903748 18.0826C0.903748 18.3699 1.13696 18.6032 1.42431 18.6032Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4383 24.8501H2.98599V25.8913H14.4383V24.8501Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.903748 27.9734H16.5206V22.7676H0.903748V27.9734ZM1.94487 23.8087H15.4794V26.9322H1.94487V23.8087Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.685 0.90332H19.6439V2.98563H20.685V0.90332Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8495 0.90332H23.8084V2.98563H24.8495V0.90332Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7673 0.90332H21.7262V2.98563H22.7673V0.90332Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.014 0.90332H27.9729V2.98563H29.014V0.90332Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0963 0.90332H30.0551V2.98563H31.0963V0.90332Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9318 0.90332H25.8907V2.98563H26.9318V0.90332Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0364 24.85H29.7032L31.0609 4.02686H19.6778L21.0364 24.85ZM21.7262 10.2738C21.7262 8.26488 23.3613 6.62975 25.3701 6.62975C27.3789 6.62975 29.014 8.26488 29.014 10.2738V18.6031C29.014 20.612 27.3789 22.2471 25.3701 22.2471C23.3613 22.2471 21.7262 20.612 21.7262 18.6031V10.2738Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3701 21.2059C26.8053 21.2059 27.9729 20.0383 27.9729 18.603V10.2738C27.9729 8.83856 26.8053 7.6709 25.3701 7.6709C23.9349 7.6709 22.7673 8.83856 22.7673 10.2738V18.603C22.7673 20.0383 23.9349 21.2059 25.3701 21.2059Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.836 27.9731H23.9047C24.1202 28.5775 24.6929 29.0143 25.3706 29.0143C26.0479 29.0143 26.6205 28.5775 26.836 27.9731Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1723 26.9323H29.5674L29.6356 25.8911H21.1046L21.1723 26.9323Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3701 30.0555C24.1135 30.0555 23.0619 29.1595 22.8199 27.9731H21.2056V30.576C21.2056 30.8634 21.4388 31.0966 21.7262 31.0966H29.014C29.3014 31.0966 29.5346 30.8634 29.5346 30.576V27.9731H27.9203C27.6783 29.1595 26.6267 30.0555 25.3701 30.0555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatment);
export default __webpack_public_path__ + "static/media/treatment.525d6034e1c6e5cb7e7d2ab31e22f970.svg";
export { ForwardRef as ReactComponent };